var _clipPath, _foreignObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-loading_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.478 0 10 0c1.364 0 2.693.274 3.923.8a1.616 1.616 0 01-1.265 2.97A6.75 6.75 0 0010 3.23 6.772 6.772 0 003.226 10 6.772 6.772 0 0010 16.77 6.772 6.772 0 0016.774 10 1.614 1.614 0 1120 10c0 5.523-4.478 10-10 10S0 15.523 0 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.825 4.213c-.31.309-.5.736-.5 1.207 0 .472.19.899.5 1.208.309.31.736.5 1.207.5.472 0 .9-.19 1.208-.5.31-.309.5-.736.5-1.208 0-.471-.19-.898-.5-1.207-.309-.31-.736-.5-1.208-.5l-.174.009c-.402.04-.763.22-1.034.49z"
  }))), _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    clipPath: "url(#logo-loading_svg__a)"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-loading_svg__gradient-logo",
    xmlns: "http://www.w3.org/1999/xhtml"
  }))));
}

export default SvgLogoLoading;